module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Clothes/Tie-0a2908144ef6964bf41c21a1c094655f5dcfa3236326a301646697ba600f71a9.svg";